import React from 'react';

import { SvgIconProps } from '@ui-core/types';

import BaseIcon from '../base-icon';

const SvgIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <BaseIcon {...props}>
      <path d="M12 15.9985C14.2083 15.9985 15.9985 14.2083 15.9985 12C15.9985 9.79165 14.2083 8.00146 12 8.00146C9.79165 8.00146 8.00146 9.79165 8.00146 12C8.00146 14.2083 9.79165 15.9985 12 15.9985Z" />
      <path d="M23.2668 9.41995C21.7164 6.89489 18.1897 2.65845 12 2.65845C5.81027 2.65845 2.28358 6.89489 0.733158 9.41995C-0.244386 11.0011 -0.244386 12.9989 0.733158 14.5801C2.28358 17.1051 5.81027 21.3416 12 21.3416C18.1897 21.3416 21.7164 17.1051 23.2668 14.5801C24.2443 12.9989 24.2443 11.0011 23.2668 9.41995ZM12 17.9978C8.68752 17.9978 6.0022 15.3124 6.0022 12C6.0022 8.68752 8.68752 6.00221 12 6.00221C15.3124 6.00221 17.9978 8.68752 17.9978 12C17.9944 15.3111 15.3111 17.9944 12 17.9978Z" />
    </BaseIcon>
  );
};

export default SvgIcon;
